import { render, staticRenderFns } from "./ProviderProfileHeader.vue?vue&type=template&id=61a4264a&"
import script from "./ProviderProfileHeader.vue?vue&type=script&lang=js&"
export * from "./ProviderProfileHeader.vue?vue&type=script&lang=js&"
import style0 from "./ProviderProfileHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports